import styled, { css } from 'styled-components';

export const FormButton = styled.div`
  display: flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  border-radius: 4px;
  background: var(--accent-color-blue);
  color: var(--primary-background);
  font-feature-settings: 'clig' off, 'liga' off;
  /* 14px/bold */
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px; /* 114.286% */
  border-radius: 4px;
  border: 1px solid var(--accent-color-blue);
  cursor: pointer;
  ${(props) =>
    !!props.variant &&
    props.variant === 'GHOST' &&
    css`
      border: 1px solid var(--accent-color-blue);
      background: var(--primary-background);
      color: var(--accent-color-blue);
    `}
  ${(props) =>
    !!props.isDisabled &&
    css`
      opacity: 0.5;
      pointer-events: none;
    `}
`;
